import { useState } from "react";
import { RadioGroup } from "@headlessui/react";
import {
  useNavigate,
  useParams,
  useSearchParams,
  useLocation,
} from "react-router-dom";
import ProductReviewCard from "./ProductReviewCard";
import {
  Box,
  Button,
  Grid,
  IconButton,
  LinearProgress,
  Rating,
} from "@mui/material";
import HomeProductCard from "../../Home/HomeProductCard";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  findProductById,
  findProducts,
} from "../../../../Redux/Customers/Product/Action";
import { addItemToCart } from "../../../../Redux/Customers/Cart/Action";
import { getAllReviews } from "../../../../Redux/Customers/Review/Action";
import { lengha_page1 } from "../../../../Data/Women/LenghaCholi";
import { gounsPage1 } from "../../../../Data/Gouns/gouns";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { TbRulerMeasure } from "react-icons/tb";
import Modal from "@mui/material/Modal";
import SizeChartTop from "../../SizeChart/SizeChartTop";
import SizeChartBottom from "../../SizeChart/SizeChartBottom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const reviews = { href: "#", average: 4, totalCount: 117 };

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const style = {
  position: "absolute",
  top: "15%",
  left: "50%",
  bottom: "75%",
  transform: "translate(-50%, -10%)",
  bgcolor: "background.paper",
  border: "none",
  // boxShadow: 24,
  // p: 4,
  overflowY: "auto",
  height: "90vh",
  width: "80%",
  outline: "none",
};

export default function ProductDetails() {
  const [selectedSize, setSelectedSize] = useState();
  const [activeImageIndex, setActiveImageIndex] = useState(0);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  // const searchParams = useSearchParams();
  const { customersProduct, review } = useSelector((store) => store);
  const { productId, category } = useParams();
  const jwt = localStorage.getItem("jwt");
  const { auth } = useSelector((store) => store);

  const [ratings, setRatings] = useState({ value: 0, count: 0 });
  const [itemCount, setItemCount] = useState(1);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  //
  const decodedQueryString = decodeURIComponent(location.search);
  const searchParams = new URLSearchParams(decodedQueryString);
  let view_all = searchParams.get("view_all");

  const product = {
    images: [
      {
        src: `${customersProduct.product?.imageUrl}`,
        alt: "Two each of gray, white, and black shirts laying flat.",
      },
      {
        src: "https://cdn.shopify.com/s/files/1/0420/7073/7058/files/d46bfb1f30f4a026ed220747858f3582.jpg?v=1728632350&width=600",
        alt: "Model wearing plain black basic tee.",
      },
      {
        src: "https://cdn.shopify.com/s/files/1/0420/7073/7058/files/d4c9d4b894721056ae231d6977d39bc0.jpg?v=1728984661&width=600",
        alt: "Model wearing plain gray basic tee.",
      },
      {
        src: "https://cdn.shopify.com/s/files/1/0420/7073/7058/files/4MST2180-03-M27.jpg?v=1696915797&width=600",
        alt: "Model wearing plain white basic tee.",
      },
    ],
    colors: [
      { name: "White", class: "bg-white", selectedClass: "ring-gray-400" },
      { name: "Gray", class: "bg-gray-200", selectedClass: "ring-gray-400" },
      { name: "Black", class: "bg-gray-900", selectedClass: "ring-gray-900" },
    ],
    description:
      'The Basic Tee 6-Pack allows you to fully express your vibrant personality with three grayscale options. Feeling adventurous? Put on a heather gray tee. Want to be a trendsetter? Try our exclusive colorway: "Black". Need to add an extra pop of color to your outfit? Our white tee has you covered.',
    highlights: [
      "Hand cut and sewn locally",
      "Dyed with our proprietary colors",
      "Pre-washed & pre-shrunk",
      "Ultra-soft 100% cotton",
    ],
    details:
      'The 6-Pack includes two black, two white, and two heather gray Basic Tees. Sign up for our subscription service and be the first to get new, exciting colors, like our upcoming "Charcoal Gray" limited release.',
  };

  const handleSetActiveImage = (index) => {
    setActiveImageIndex(index);
    // window.scrollTo(0, 150);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!auth.user) {
      toast.error("Please Sing-In");
      return;
    }
    if (customersProduct?.product?.isSizesAvailable && !selectedSize) {
      toast.error("Select a size!");
    } else {
      const data = { productId, size: selectedSize?.name, quantity: itemCount };

      await dispatch(addItemToCart({ data, jwt }));
      navigate("/cart");
    }
  };

  let ratingValue;
  let ratingCounts;
  useEffect(() => {
    ratingValue = Number((Math.random() * 1 + 4).toFixed(2));
    ratingCounts = Math.floor(Math.random() * 200 + 500);
    setRatings({
      value: ratingValue,
      count: ratingCounts,
    });
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    const data = { productId: productId, jwt };
    dispatch(findProductById(data));
    // dispatch(getAllReviews(productId));

    const queryData = {
      category: category,
      colors: [],
      sizes: [],
      minPrice: 0,
      maxPrice: 10000,
      minDiscount: 0,
      sort: "price_low",
      pageNumber: 1,
      pageSize: 50,
      stock: null,
      view_all: view_all,
      similar_products: true,
      excludingProductId: productId,
    };
    dispatch(findProducts(queryData));
  }, [productId]);

  // useEffect(() => {
  // }, [category]);
  //

  const handleSizeIncrease = (product) => {
    if (product?.isSizesAvailable && !selectedSize) {
      toast.error("Select a Size!");
      return;
    } else {
      if (
        customersProduct?.product?.sizes?.find(
          (item) => item?.name == selectedSize?.name
        )?.quantity == itemCount
      ) {
        toast.error("Quantity Not Available!");
        return;
      } else if (
        !customersProduct?.product?.isSizesAvailable &&
        customersProduct?.product.quantity == itemCount
      ) {
        toast.error("Quantity Not Available!");
        return;
      }
    }
    setItemCount(itemCount + 1);
  };

  useEffect(() => {
    setItemCount(1);
  }, [selectedSize]);

  const sizeChangeHanlder = (e) => {
    const { name, quantity } = e;
    const isQuanityAvailable = quantity <= 0 ? false : true;

    if (isQuanityAvailable) {
      setSelectedSize(e);
    } else {
      setSelectedSize("");
    }
  };

  return (
    <div className="lg:px-20">
      {/* <ToastContainer 
        transition="Flip"
      
      /> */}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        // transition="Flip"
      />
      <div className="pt-3">
        {/* product details */}
        <section className="grid grid-cols-1 gap-x-8 gap-y-10 lg:grid-cols-2 px-4 mt-10">
          {/* Image gallery */}
          <div className="flex flex-col items-center">
            <div className=" rounded-lg max-w-[20rem] max-h-[35rem] flex items-center justify-center">
              <ArrowBackIcon
                className="cursor-pointer mr-3"
                onClick={() =>
                  handleSetActiveImage(
                    activeImageIndex == 0
                      ? customersProduct.product?.images?.length - 1
                      : activeImageIndex - 1
                  )
                }
              />
              <img
                src={
                  activeImageIndex
                    ? `${customersProduct.product?.images[activeImageIndex]}`
                    : `${customersProduct.product?.images[0]}`
                }
                alt={product.title}
                className="h-full w-full object-cover object-center"
              />
              {/* <ArrowBackIcon className="z-40"/> */}

              <ArrowForwardIcon
                className="cursor-pointer ml-3"
                onClick={() =>
                  handleSetActiveImage(
                    customersProduct.product?.images?.length - 1 ==
                      activeImageIndex
                      ? 0
                      : activeImageIndex + 1
                  )
                }
              />
            </div>
          </div>

          {/* Product info */}
          <div className="lg:col-span-1 mx-auto px-4 pb-16 sm:px-6 lg:pb-24">
            <div className="lg:col-span-2">
              <h1 className="text-base lg:text-base font-semibold tracking-tight text-[#b28585]">
                {customersProduct.product?.brand}
              </h1>
              <h1 className="text-lg lg:text-lg tracking-tight text-gray-900 opacity-60 pt-1">
                {customersProduct.product?.title}
              </h1>
            </div>

            {/* Options */}
            <div className="mt-4 lg:mt-0">
              <div className="flex text-lg lg:text-xl text-gray-900 mt-6 justify-start">
                <p className="font-semibold mr-3">
                  ₹{customersProduct.product?.discountedPrice}
                </p>
                <p className="text-gray-500 line-through">
                  ₹{customersProduct.product?.price}
                </p>
                <p className="text-red-600 font-semibold">
                  ({customersProduct.product?.discountPercent}% Off)
                </p>
              </div>

              <form className="mt-5" onSubmit={(e) => handleSubmit(e)}>
                <div>
                  {customersProduct.product?.thirdLavelCategory.wearType && (
                    <p
                      className="text-sm underline cursor-pointer text-[#9BA0A1] flex items-center"
                      onClick={handleOpen}
                    >
                      <TbRulerMeasure className="mr-1" /> Size Chart
                    </p>
                  )}
                </div>
                {/* Sizes */}
                {customersProduct?.product?.isSizesAvailable && (
                  <div className="">
                    <div className="flex items-center w-3/4 lg:w-1/2  justify-between">
                      <h3 className="text-sm font-medium text-gray-900">
                        Size:
                      </h3>
                      {/* <h3 className="text-sm font-medium text-gray-900">
                      Size Chart
                    </h3> */}
                    </div>

                    <RadioGroup
                      value={selectedSize}
                      onChange={(e) => sizeChangeHanlder(e)}
                      className="mt-4"
                    >
                      <RadioGroup.Label className="sr-only">
                        Choose a size
                      </RadioGroup.Label>

                      <div className="grid grid-cols-7 gap-5 sm:grid-cols-4 lg:grid-cols-9">
                        {customersProduct.product?.sizes.map((size) => (
                          <RadioGroup.Option
                            key={size.name}
                            value={size}
                            disabled={Number(size.quantity) == 0}
                            className={({ active }) =>
                              classNames(
                                Number(size.quantity) > 0
                                  ? "cursor-pointer text-gray-900 shadow-sm"
                                  : "cursor-not-allowed bg-gray-50 text-gray-200",
                                selectedSize?.name == size.name
                                  ? "border border-[#b28585]"
                                  : "border",
                                "group relative flex items-center justify-center text-sm uppercase focus:outline-none py-2 px-3"
                              )
                            }
                          >
                            {({ active, checked }) => (
                              <>
                                <RadioGroup.Label as="span">
                                  {size.name}
                                </RadioGroup.Label>
                                {Number(size.quantity) > 0 ? (
                                  <span
                                    className={classNames(
                                      selectedSize?.name
                                        ? "border border-[#b28585]"
                                        : "border",
                                      selectedSize?.name
                                        ? "border border-[#b28585]"
                                        : "border-transparent",
                                      "pointer-events-none absolute rounded-md"
                                    )}
                                    aria-hidden="true"
                                  />
                                ) : (
                                  <span
                                    aria-hidden="true"
                                    className="pointer-events-none absolute -inset-px rounded-md border-2 border-gray-200"
                                  >
                                    <svg
                                      className="absolute inset-0 h-full w-full stroke-2 text-gray-200"
                                      viewBox="0 0 100 100"
                                      preserveAspectRatio="none"
                                      stroke="currentColor"
                                    ></svg>
                                  </span>
                                )}
                              </>
                            )}
                          </RadioGroup.Option>
                        ))}
                      </div>
                    </RadioGroup>
                  </div>
                )}

                <div className="flex items-center lg:space-x-10 pt-4">
                  <div className="flex items-center space-x-2 ">
                    <IconButton
                      onClick={() => setItemCount(itemCount - 1)}
                      disabled={itemCount <= 1}
                      // color="primary"
                      aria-label="add an alarm"
                      sx={{
                        color: "#b28585",
                      }}
                    >
                      <RemoveCircleOutlineIcon />
                    </IconButton>

                    <span className="py-1 px-7 border rounded-sm">
                      {/* {item?.quantity} */}
                      {itemCount}
                    </span>
                    <IconButton
                      // onClick={() => handleUpdateCartItem(1)}
                      onClick={() => {
                        handleSizeIncrease(customersProduct.product);
                      }}
                      // color="primary"
                      aria-label="add an alarm"
                      sx={{
                        color: "#b28585",
                      }}
                    >
                      <AddCircleOutlineIcon />
                    </IconButton>
                  </div>
                </div>

                <Button
                  variant="contained"
                  type="submit"
                  sx={[
                    {
                      "&:hover": {
                        backgroundColor: "#b98f8f !important",
                      },
                    },
                    {
                      padding: ".8rem 2rem",
                      marginTop: "3rem",
                      backgroundColor: "#b28585",
                    },
                  ]}
                >
                  Add To Cart
                </Button>
              </form>
            </div>

            <div className="pt-10 lg:mt-3">
              {/* Description and details */}
              <div className="ml-4 mb-8">
                <h3 className="mb-3">Description</h3>

                <div className="space-y-6">
                  <p className="text-base text-gray-500 break-all">
                    {customersProduct.product?.description}
                  </p>
                </div>
              </div>

              <Accordion
                sx={{
                  backgroundColor: "#FFFBF2",
                  border: "none",
                  boxShadow: "none",
                  margin: 0,
                  padding: 0,
                }}
              >
                <AccordionSummary
                  expandIcon={<ArrowDropDownIcon />}
                  aria-controls="panel2-content"
                  id="panel2-header"
                >
                  <h3 className="mb-3">Shipping Information</h3>
                </AccordionSummary>
                <AccordionDetails>
                  <p className="text-base text-gray-500">
                    {/* {customersProduct.product?.description} */}
                    We collaborate with trusted manufacturers to source
                    premium-quality products for our customers. Every item
                    undergoes thorough checks and processes to ensure it meets
                    our high standards. Typically, orders are processed and
                    delivered within 20-25 business working days. If you need
                    your order urgently, please contact us at +91 9784254025 or
                    email us at contact@aashapurasafahouse.com, and we will do
                    our best to assist you promptly.
                  </p>
                </AccordionDetails>
              </Accordion>
            </div>
          </div>
        </section>

        {/* similer product */}
        <section className="mt-3">
          <h1 className="py-5 text-xl font-bold text-[#b28585] ml-3">
            Similer Products
          </h1>
          <div className="grid grid-cols-2 gap-x-2 gap-y-10 md:grid-cols-3 lg:grid-cols-5 px-4 mb-10">
            {customersProduct?.products[`${category}`]?.content?.map((item) => (
              <HomeProductCard
                product={item}
                category={category}
                view_all={view_all}
              />
            ))}
          </div>
        </section>
      </div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          {customersProduct.product?.thirdLavelCategory?.wearType == "top" ? (
            <SizeChartTop />
          ) : (
            <SizeChartBottom />
          )}
        </Box>
      </Modal>
    </div>
  );
}
